
import Vue, { PropType } from 'vue'
import JFileInput from '@/ui/controls/JFileInput.vue'

import { db, storage } from '@/firebase'
import { uploadAvatar } from '@/firebase/storage'
import JFileContainer from '@/models/JFileContainer'
import Plant from '@/models/Plant'
import Avatar from '@/models/Avatar'

// import { getFileExtension } from '@/helpers/fileHelpers'

// const BASE_PATH = 'plants'

export default Vue.extend({
  components: {
    JFileInput,
  },
  props: {
    plant: Object as PropType<Plant>,
  },
  data: () => ({
    images: [] as Array<JFileContainer>,
  }),
  computed: {
    canUpload(): boolean {
      return this.images.length === 1
    },
    path() {
      return () =>
        [
          'gardens',
          this.plant.gardenId,
          'plants',
          this.plant.id,
          'avatar',
          'avatar',
        ].join('/')
    },
  },
  methods: {
    upload(): void {
      if (!this.images || this.images.length < 1 || this.images.length > 1) {
        this.$store.dispatch('snackbars/error', 'invalid image selection')
        return
      }

      const jfile = this.images[0]

      uploadAvatar(
        jfile,
        storage.ref(
          `gardens/${this.plant.gardenId}/plants/${this.plant.id}/avatar/avatar`
        ),
        db
          .doc('gardens', this.plant.gardenId, 'plants', this.plant.id)
          .withConverter(Avatar.firestoreConverter(this.plant.id))
      )
        .then(() =>
          this.$store.dispatch('snackbars/success', 'Uploaded image!')
        )
        .catch((err: Error) =>
          this.$store.dispatch('snackbars/error', err.message)
        )

      // uploadImageToFirestoreRef(
      //   this.images[0],
      //   db.collection('gardens').doc(gardenId).collection('images').doc();
      //   // db.collection('gardens').doc(this.plant.gardenId).collection('plants').doc(this.plant.id), 'avatar', 'avatar']
      // )
      // uploadFile(this.images[0], this.path)
      //   .then((jfile: JFileContainer) =>
      //     this.$store.dispatch('gardens/plants/update', { gardenId: this.plant.gardenId, id: this.plant.id, updates: { avatar: jfile.url } }))
      //   .then(() => this.$store.dispatch('snackbars/success', 'Uploaded image!'))
      //   .catch((err: Error) => this.$store.dispatch('snackbars/error', err.message))
    },
  },
})
